/** Plain text from message HTML (for clipboard). */
export function messageTextPlain(html: string | null | undefined): string {
  if (!html?.trim()) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return (div.innerText ?? div.textContent ?? '').trim();
}
